<button class="btn btn-back w-fitcontent background px-3 px-md-5 py-md-5 py-3" (click)="goToHomePage()">
  <fa-icon [icon]="faChevronLeft" class="fill-orange"></fa-icon>
  <span class="ms-2">
    {{ "actions.homepage" | translate }}
  </span>
</button>

<div fxLayout="row" fxLayout.lt-sm="column" fxLayoutAlign="space-between stretch">
  <div>
    <div class="px-3 px-md-5">
      <div class="color-black ">
        <h1 class="mb-3" translate="">user-manual.title</h1>
        <h3 translate>user-manual.body
          <a class="pointer underline" [href]="'/assets/downloads/manual/' + manualFileName" target="_blank">
            {{'generic.link' |translate}}
          </a>
        </h3>
      </div>
    </div>
    <div class="text-center frame-container">
      <iframe class="e2e-iframe-trusted-src" allowfullscreen class="video-iframe" [src]="url" frameborder="0"></iframe>
    </div>
  </div>
</div>
